import { useTranslation } from 'react-i18next';

const LevelUpTableHeader = () => {
  const { t } = useTranslation();
  return (
    <>
      <thead>
        <tr>
          <th className="align-middle" rowSpan={2}>
            {t('common.menu.campus')}
          </th>
          <th className="align-middle" rowSpan={2} style={{ width: '10%' }}>
            {t('class.class.column82')}
          </th>
          <th className="align-middle" rowSpan={2} style={{ width: '10%' }}>
            {t('common.menu.class')}
          </th>

          <th>MT1</th>
          <th>MT2</th>
          <th>TT</th>
          <th>iCoaching</th>
          <th>e-Learning</th>
          <th>{t('class.levelUp.column2')}</th>
          <th className="align-middle" rowSpan={2} style={{ width: 80 }}>
            {t('class.course.count')}
          </th>
          <th className="align-middle" rowSpan={2}>
            RnD
            <br />
            {t('class.levelUp.column3')}
          </th>
          <th className="align-middle" rowSpan={2}>
            {t('common.menu.campus')}
            <br />
            {t('class.levelUp.column3')}
          </th>
          <th className="align-middle" rowSpan={2}>
            {t('class.levelUp.column3')}
            <br />
            {t('class.levelUp.placeholder1')}
          </th>
        </tr>
        <tr>
          <th>({t('class.levelUp.column4')})</th>
          <th>({t('class.levelUp.column4')})</th>
          <th>({t('class.levelUp.column4')})</th>
          <th>({t('class.levelUp.column4')})</th>
          <th>({t('class.levelUp.column4')})</th>
          <th>({t('class.levelUp.column4')})</th>
        </tr>
      </thead>
    </>
  );
};

export default LevelUpTableHeader;
